// Client-side mirror of the server's clinic code rules
// (physio_server/src/business/cliniccode.js). This is for immediate feedback in
// the form; the server re-checks everything, and it alone can check uniqueness.

export const CLINIC_CODE_MIN = 1001
export const CLINIC_CODE_MAX = 9998

export const normalizeClinicCode = (value) =>
  value === null || value === undefined ? '' : String(value).trim()

export const isValidClinicCode = (value) => {
  const code = normalizeClinicCode(value)
  if (!/^[0-9]{4}$/.test(code)) return false
  const n = Number(code)
  return n >= CLINIC_CODE_MIN && n <= CLINIC_CODE_MAX
}

export const CLINIC_CODE_RANGE_MESSAGE =
  'Clinic code must be a number between ' +
  CLINIC_CODE_MIN +
  ' and ' +
  CLINIC_CODE_MAX

// The server's clinic-code refusals all name the field, which is how the form
// knows to show the message under the Clinic Code input rather than as a toast.
export const isClinicCodeError = (msg) =>
  typeof msg === 'string' && msg.toLowerCase().indexOf('clinic code') !== -1

export default {
  CLINIC_CODE_MIN,
  CLINIC_CODE_MAX,
  CLINIC_CODE_RANGE_MESSAGE,
  normalizeClinicCode,
  isValidClinicCode,
}
